import { Component } from '@angular/core';

@Component({
  selector: 'app-intake-reports',
  templateUrl: './intake-reports.component.html',
  styleUrls: ['./intake-reports.component.scss']
})
export class IntakeReportsComponent {

}


